import { Fragment } from "react";
import "../../exam/components/question/QuestionCard/QuestionCard.css";
import RenderMathQuestion from "../../../../shared/components/RenderMathQuestion/RenderMathQuestion";
import { optionLables } from "../../../../shared/utilities/constants/optionLabels";
import ExerciseQuestionHeader from "./ExerciseQuestionHeader";
import {
  getExerciseAnswerTypeId,
  getExerciseQuestionOptions,
  getExerciseQuestionText,
  isOptionSelected,
} from "../utils/exerciseExamUtils";

const ExerciseQuestionCard = ({
  question,
  questionNumber,
  currentLang,
  onToggleLanguage,
  onToggleBookmark,
  onSelectOption,
  onIntegerAnswerChange,
}) => {
  if (!question) return null;

  const answerTypeId = getExerciseAnswerTypeId(question);
  const options = getExerciseQuestionOptions(question, currentLang);
  const questionText = getExerciseQuestionText(question, currentLang);
  const isHindiAvailable = Boolean(question?.q_text_hindi);

  const handleIntegerChange = (event) => {
    const value = event.target.value;
    // Exercise answers allow a leading minus and up to two decimals.
    if (/^-?\d*\.?\d{0,2}$/.test(value)) {
      onIntegerAnswerChange?.(value);
    }
  };

  return (
    <div className="exam__question_card">
      <ExerciseQuestionHeader
        question={question}
        questionNumber={questionNumber}
        currentLang={currentLang}
        onToggleLanguage={onToggleLanguage}
        onToggleBookmark={onToggleBookmark}
        isHindiAvailable={isHindiAvailable}
      />

      <div className="exam__question_card__question">
        <RenderMathQuestion question={questionText || ""} />
      </div>

      <div className="exam__question_card__options">
        {answerTypeId === 3 ? (
          <div className="exam__question_card__integer_input">
            <input
              type="text"
              value={question?.integer_answer ?? ""}
              onChange={handleIntegerChange}
              placeholder="Type your answer here"
            />
          </div>
        ) : (
          <Fragment>
            {options.map((option, index) => {
              const isSelected = isOptionSelected(question, option.option_id);

              return (
                <div
                  key={option.option_id ?? index}
                  className={`exam__question_card__option ${
                    isSelected ? "selected" : ""
                  }`}
                  onClick={() => onSelectOption?.(option.option_id)}
                >
                  <span
                    className={`exam__question_card__option_label ${
                      isSelected ? "selected-label" : "not-selected-label"
                    }`}
                  >
                    {optionLables[index]}
                  </span>

                  <RenderMathQuestion
                    question={String(option.option ?? "")}
                  />
                </div>
              );
            })}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default ExerciseQuestionCard;
